/** Problem-details body from the Velinko API (RFC 7807): the message is in `detail`. */
export interface ApiError {
  code: string | null;
  message: string;
}

export const NOT_APPROVED = 'NOT_APPROVED';

export async function readApiError(res: Response, fallback: string): Promise<ApiError> {
  const body = (await res.json().catch(() => null)) as {
    code?: string;
    detail?: string;
    fieldErrors?: Array<{ message?: string }>;
    error?: { message?: string };
  } | null;
  const message =
    body?.fieldErrors?.[0]?.message ?? body?.detail ?? body?.error?.message ?? fallback;
  return { code: body?.code ?? null, message };
}

/** Tokens are useless once the account is not approved; drop them and explain on the sign-in page. */
export function signOutNotApproved(
  navigate: (to: string, opts?: { replace?: boolean }) => void,
): void {
  localStorage.removeItem('velinko_token');
  localStorage.removeItem('velinko_refresh_token');
  navigate('/login?reason=not_approved', { replace: true });
}
